<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-2">
      <span style="font-size: 14px; color: #606266"
        >Bill No：{{ formData.stockBatchReturnNo }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>Status：{{ formData.billStatusName }}</span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Create：{{ formData.createByName }} at
        {{ formData.createDate }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName }} at
        {{ formData.modifyDate }}
      </span>
    </div>
  </div>
</template>
<script>
// import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    formData: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {}
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
    async getFormData() {
      // const result = await validate.formValidate([this.$refs.form])
      // if (!result) {
      //   this.$message.error(
      //     this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
      //       '有必输字段未填写，请检查'
      //   )
      //   return
      // }
      return this.formData
    },
  },
}
</script>
